import { Injectable } from "@angular/core";

// import { getFirebaseBackend } from '../../authUtils';

import { User } from "../models/auth.models";
import { HttpClient } from "@angular/common/http";
import { EnvService } from "./env.service";
import { map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  user: User;
  private currentUserSubject: BehaviorSubject<User>;
  constructor(
    private router: Router,
    private http: HttpClient,
    private envService: EnvService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    // return getFirebaseBackend().getAuthenticatedUser();
    return;
  }

  /**
   * Returns the current user
   */
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  /**
   * Performs the auth
   * @param formData
   */
  login(credential) {
    console.log("logging in...");
    return this.http
      .post<any>(`${this.envService.httpService}/auth/admin-login`, credential)
      .pipe(
        map((user) => {
          // login successful if there's a jwt token in the response
          console.log("user__service__response ::", user);
          if (user?.data && user?.data?.accessToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(
              "menuList",
              JSON.stringify(user?.data?.menuList)
            );
            localStorage.setItem("currentUser", JSON.stringify(user?.data));
            localStorage.setItem(
              "token",
              JSON.stringify(user?.data?.accessToken)
            );
            this.currentUserSubject.next(user?.data);
          }
          return user;
        })
      );
  }

  /**
   * Performs the register
   * @param email email
   * @param password password
   */
  register(email: string, password: string) {
    // return getFirebaseBackend().registerUser(email, password).then((response: any) => {
    //     const user = response;
    //     return user;
    // });
    return;
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    // return getFirebaseBackend().forgetPassword(email).then((response: any) => {
    //     const message = response.data;
    //     return message;
    // });
    return;
  }

  /**
   * Logout the user
   */
  logout() {
    // logout the user
    // localStorage.removeItem("currentUser");
    // localStorage.removeItem("menuList");
    // localStorage.removeItem("token");
    localStorage.clear();
    this.currentUserSubject.next(null);
    this.router.navigate(["/account/login"]);
  }
}
